import { render, staticRenderFns } from "./TheBasePageLayout.vue?vue&type=template&id=0e930b6c&scoped=true"
import script from "./TheBasePageLayout.vue?vue&type=script&lang=js"
export * from "./TheBasePageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._pvxtve42dn25yfzifbo3bypexu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e930b6c",
  null
  
)

export default component.exports